var productCardMarkup = `
 <div class="wishlist_products">
 <ul class="small-form">
 {{#products}}
	<li>
      <div class="grid-view-item product-card">
        <a class="grid-view-item__link grid-view-item__image-container full-width-link" href="{{du}}">
          <span class="visually-hidden">{{dt}}</span>
        </a>
        <div class="left">
          <div class="grid-view-item__image-wrapper product-card__image-wrapper js">
            <div>
              <img  class="grid-view-item__image lazyautosizes" src="{{iu}}" />
            </div>
          </div>
        </div>

        <div class="right">
             <dl class="vendor">
              <span class="vendor-item">{{bt}}</span>
            </dl> 
          <div class="h4 grid-view-item__title product-card__title" aria-hidden="true">{{dt}} </div>
             
            <dl class="variant">
              <span class="variant-item">{{variantinfo}}</span>
            </dl>  
            <dl class="price" data-price="">
             
              <span class="price-item price-item--sale" data-sale-price="">
                {{cu}}{{pr}}
              </span>
            </dl>
            <div id="{{empi}}" class="wishlist-simple-popup {{empi}}" style="display: none;">Product Sold Out</div>
            <a href="" id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="add-to-cart wishlist_action_btn desktop-only">
             Remove
           </a>
            <a href="" id="{{empi}}-btn" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" class="add-to-cart added-to-cart wishlist_action_btn desktop-only">
    			{{#isInCart}}Add to Bag{{/isInCart}}
    			{{^isInCart}}Add to Bag{{/isInCart}}
    		</a>
            
        </div>
        
        <div class="wishlist_action_mobile mobile-only">
          <a href="" id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="add-to-cart wishlist_action_btn">
             Remove
           </a>
            <a href="" id="{{empi}}-btnmobile" data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" class="add-to-cart added-to-cart wishlist_action_btn">
    			{{#isInCart}}Add to Bag{{/isInCart}}
    			{{^isInCart}}Add to Bag{{/isInCart}}
    		</a>
        </div>
		
      </div>
    </li>
  {{/products}}
 </ul>
 </div>
`;


function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		} else{
		  //console.log("Container not found, Wishlist Page element not found");
		}
	});
}


function onAddToCartClick(e){
  e.preventDefault();
  var productId = e.target.getAttribute("data-product-id");
  var variantId = e.target.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart(
   {empi: productId, du: du},
   variantId,
   function() {
     e.target.innerHTML = "Added to bag";
     window.location.reload();
     //console.log("Successfully added product to cart.");
   },
   function(e) {
     //console.log(e);
     document.getElementById(productId).style.display = 'block';
     document.getElementById(productId + '-btn').setAttribute("disabled", "true");
     document.getElementById(productId + '-btn').setAttribute("style", "color:grey;cursor:default;");
     const emt = document.getElementById(productId + '-btn');
     emt.innerHTML = "Added to Bag";

     /*Mobile*/
     document.getElementById(productId + '-btnmobile').setAttribute("disabled", "true");
     document.getElementById(productId + '-btnmobile').setAttribute("style", "color:grey;");
     document.getElementById(productId + '-btnmobile').setAttribute("style", "cursor:default;");
     const emtmobile = document.getElementById(productId + '-btnmobile');
     emtmobile.innerHTML = "Added to Bag";
   }
  );
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi){
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}


function attachClickListeners() {
	var addToCartButtons = document.getElementsByClassName("added-to-cart");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	//console.log("Events attached!");
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

